import styled from "styled-components";
import Card from "@material-ui/core/Card";

const WhatHotListWrapper = styled(Card)`
  display: flex;
  margin-bottom: 15px;
  border: 1px solid #DDD;
  box-shadow: unset;
  width: 100%;
  cursor: pointer;
  .collection-image {
    width: 111px;
    height: 120px;
  }
  .collection-details {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    position: relative;
    width: calc(100% - 111px);
    .collection-details-content {
      padding-right: 0;
      padding-bottom: 0;
      h5 {
        color: black;
        font-size: 21px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
      h6 {
        color: rgba(0,0,0,0.6);
        font-size: 14px;
      }
    }

    .collection-list-share-btn{
      padding: 10px;
      position: absolute;
      bottom: 3px;
      right: 4px;
      &:hover {
        border-radius: 50% !important;
      }
      svg {
        font-size: 18px;
      }
    }

    .collection-title {
      color: black;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      white-space: nowrap;
      display: block;
      height: 21px;
    }
  }
`;

export default WhatHotListWrapper;